"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var decoration_1 = require("../basic/decoration");
var card_1 = require("../schema/card");
var formatter_1 = require("../formatter");
var createShadowWrapper = function (inline) {
    var dom;
    if (inline)
        dom = card_1.createInlineCardDOM();
    else
        dom = card_1.createCardDOM();
    dom.setAttribute(formatter_1.IG_EL, 'true');
    return dom;
};
var getShadows = function (state, key, start, end) {
    var specMatch;
    if (key) {
        if (typeof key === 'string') {
            specMatch = function (_spec) { return _spec.key === key; };
        }
        else if (typeof key === 'function') {
            specMatch = key;
        }
    }
    var decorations = decoration_1.DecoKey.getState(state).find(start, end, specMatch);
    return decorations;
};
exports.getShadows = getShadows;
// data需要有pos, shadow
var insertShadow = function (state, dispatch, data, inline) {
    var tr = state.tr;
    var fixPos = 0;
    if (inline && data.editable) {
        tr = state.tr.insert(data.pos, state.schema.text('\u200B\u200B'));
        fixPos = 1;
    }
    dispatch(tr.setMeta(decoration_1.DecoKey, {
        action: 'add',
        data: __assign(__assign({}, data), { pos: data.pos + fixPos, spec: __assign(__assign({}, data.spec), { shadowType: inline ? 'inline' : 'block' }) }),
        dom: createShadowWrapper(inline)
    }));
};
exports.insertShadow = insertShadow;
var removeShadow = function (state, dispatch, key) {
    var decorations = getShadows(state, key);
    if (!decorations.length)
        return;
    var _a = decorations[0], from = _a.from, to = _a.to, spec = _a.spec;
    var $pos = state.tr.doc.resolve(from);
    var fixPos = 0;
    if ($pos.nodeBefore && $pos.nodeBefore.textContent.match(/\u200B$/)) {
        fixPos = -1;
    }
    dispatch(state.tr.setMeta(decoration_1.DecoKey, {
        action: 'remove',
        data: {
            spec: { key: key }
        }
    }));
    return {
        spec: spec,
        from: from + fixPos,
        to: to + fixPos
    };
};
exports.removeShadow = removeShadow;
// data需要有from, to,
var appendShadow = function (state, dispatch, data, inline) {
    dispatch(state.tr.setMeta(decoration_1.DecoKey, {
        action: inline ? 'appendInline' : 'appendNode',
        data: data
    }));
};
exports.appendShadow = appendShadow;
//# sourceMappingURL=shadow.js.map